import { Box, Grid, Typography, Paper } from "@mui/material";
import { formatPrecisaoFloat, formatPrice, unformatPrice } from "../../../../utils";
import { calculoDesconto, formatProdutosTotalizadores, totalItens, totalVenda } from "../add-orcamento-servico";
import { CurrencyInput, IconButton, TextFielDecimalNumbers } from "../../../../components";
import { useState } from "react";

const ResumoTotal = ({ 
  orcamentoServico,
  setOrcamentoServico,
  orcamentoServicoEntity,
  abaValue,
  listaServicos,
  setListaServicos,
  listaProdutos,
  setListaProdutos
}) => {

  const descontoFieldStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#f8fafd",
    padding: "11px 16px",
    borderRadius: "8px",
    height: "100%",
    gap: 2
  };

  const itemStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f8fafd",
    padding: "8px 6px",
    borderRadius: "8px",
    height: "100%",
  };

  const labelStyle = {
    color: "#6b7280",
    fontWeight: 600,
    fontSize: { xs: "0.65rem", sm: "0.7rem" },
    textAlign: "center",
    mb: 0.5,
    whiteSpace: "nowrap",
  };

  const valueBadgeStyle = {
    backgroundColor: "#2196f3",
    color: "#ffffff",
    padding: { xs: "2px 6px", sm: "2px 8px" },
    borderRadius: "16px",
    fontWeight: 700,
    fontSize: { xs: "0.65rem", sm: "0.7rem" },
    width: "100%",
    maxWidth: "110px",
    textAlign: "center",
  };

  const [showAbaDescontos, setShowAbaDescontos] = useState(false);

  const toggleAbaDescontos = () => {
    setShowAbaDescontos((prev) => !prev);
  };

  const handleInputDescontoProduto = (event) => {
    if (listaProdutos?.length) {
      const name = "desconto";
      const valor = unformatPrice(event.target.value);
      if (
        parseFloat(orcamentoServico[event.target.name].toFixed(2)) !==
        formatPrecisaoFloat(parseFloat(valor))
      ) {
        const totalNota = totalVenda(orcamentoServico, listaProdutos, name);
        const orcamentoServicoTemp = {
          ...orcamentoServico,
          [event.target.name]: valor || 0,
        };
        if (event.target.name === "descontoProduto") {
          const listItensDesconto = formatProdutosTotalizadores(
            name,
            listaProdutos,
            valor,
            totalNota,
          );
          setListaProdutos(listItensDesconto);
          orcamentoServicoEntity.setChangeItens(listItensDesconto);
          setOrcamentoServico(orcamentoServicoEntity);
        } else {
          const desconto = calculoDesconto(
            listaProdutos,
            orcamentoServicoTemp,
            "descontoProduto",
            "descontoProdutoPorcentagem",
          );
          const listItensDesconto = formatProdutosTotalizadores(
            name,
            listaProdutos,
            desconto,
            totalNota,
          );
          setListaProdutos(listItensDesconto);
          orcamentoServicoEntity.setChangeItens(listItensDesconto);
          setOrcamentoServico(orcamentoServicoEntity);
        }
      }
    }
  };

  const handleInputDescontoServico = (event) => {
    if (listaServicos?.length) {
      const name = "desconto";
      const valor = unformatPrice(event.target.value);
      if (
        parseFloat(orcamentoServico[event.target.name].toFixed(2)) !==
        formatPrecisaoFloat(parseFloat(valor))
      ) {
        const totalNota = totalVenda(orcamentoServico, listaServicos, name);
        const orcamentoServicoTemp = {
          ...orcamentoServico,
          [event.target.name]: valor || 0,
        };
        if (event.target.name === "descontoServico") {
          const listItensDesconto = formatProdutosTotalizadores(
            name,
            listaServicos,
            valor,
            totalNota,
          );
          setListaServicos(listItensDesconto);
          orcamentoServicoEntity.setChangeServicos(listItensDesconto);
          setOrcamentoServico(orcamentoServicoEntity);
        } else {
          const desconto = calculoDesconto(
            listaServicos,
            orcamentoServicoTemp,
            "descontoServico",
            "descontoServicoPorcentagem",
          );
          const listItensDesconto = formatProdutosTotalizadores(
            name,
            listaServicos,
            desconto,
            totalNota,
          );
          setListaServicos(listItensDesconto);
          orcamentoServicoEntity.setChangeServicos(listItensDesconto);
          setOrcamentoServico(orcamentoServicoEntity);
        }
      }
    }
  };

  const nextFocusInput = (event) => {
    if (event.keyCode === 13) {
      const { form } = event.target;
      const arrayInput = Array.from(form.elements).filter(
        (element) => element.tagName == "INPUT",
      );
      const index = arrayInput.indexOf(event.target);
      let element = arrayInput[index + 1];
      if (element?.disabled) {
        element = arrayInput[index + 2];
      }
      if (element) {
        element.focus();
      } else {
        arrayInput[index].blur();
      }
      event.preventDefault();
    }
  };

  const renderTotaisServicos = () => {
    return (
      <>
        <Grid item xs={6} sm={5} md={3.5}>
          <ResumoItem
            label="Subtotal Serv."
            value={orcamentoServico?.totalServicos}
          />
        </Grid>
        <Grid
          item
          xs={5}
          md={5}
          className="d-flex align-items-center justify-content-end gap-2"
        >
          <Paper 
            elevation={0} 
            sx={descontoFieldStyle}
          >
            <Typography sx={labelStyle}>Desconto:</Typography>
            <TextFielDecimalNumbers
              id="descontoServicoPorcentagem"
              name="descontoServicoPorcentagem"
              variant="outlined"
              disabled={
                orcamentoServico?.status === "FECHADO" || listaServicos.length === 0
              }
              margin="none"
              size="small"
              value={orcamentoServico?.descontoServicoPorcentagem ?? 0}
              onBlur={handleInputDescontoServico}
              onKeyDown={nextFocusInput}
            />
            <CurrencyInput
              id="descontoServico"
              name="descontoServico"
              variant="outlined"
              disabled={
                orcamentoServico?.status === "FECHADO" || listaServicos.length === 0
              }
              margin="none"
              size="small"
              value={orcamentoServico.descontoServico ?? 0}
              onBlur={handleInputDescontoServico}
              onKeyDown={nextFocusInput}
            />
          </Paper>
        </Grid>
        <Grid item xs={6} sm={5} md={3.5}>
          <ResumoItem
            label="Total Serv."
            value={totalItens(orcamentoServico?.servicos)}
          />
        </Grid>
      </>
    );
  };

  const renderTotaisProdutos = () => {
    return (
      <>
        <Grid item xs={6} sm={5} md={3.5}>
          <ResumoItem label="Subtotal Prod." value={orcamentoServico?.totalItens} />
        </Grid>
        <Grid
          item
          xs={5}
          md={5}
          className="d-flex align-items-center justify-content-end gap-2"
        >
          <Paper 
            elevation={0} 
            sx={descontoFieldStyle}
          >
            <Typography sx={labelStyle}>Desconto:</Typography>
            <TextFielDecimalNumbers
              id="descontoProdutoPorcentagem"
              name="descontoProdutoPorcentagem"
              variant="outlined"
              disabled={
                orcamentoServico?.status === "FECHADO" || listaProdutos.length === 0
              }
              margin="none"
              size="small"
              value={orcamentoServico?.descontoProdutoPorcentagem ?? 0}
              onBlur={handleInputDescontoProduto}
              onKeyDown={nextFocusInput}
            />
            <CurrencyInput
              id="descontoProduto"
              name="descontoProduto"
              variant="outlined"
              disabled={
                orcamentoServico?.status === "FECHADO" || listaProdutos.length === 0
              }
              margin="none"
              size="small"
              value={orcamentoServico.descontoProduto ?? 0}
              onBlur={handleInputDescontoProduto}
              onKeyDown={nextFocusInput}
            />
          </Paper>
        </Grid>
        <Grid item xs={6} sm={3} md={3.5}>
          <ResumoItem
            label="Total Prod."
            value={totalItens(orcamentoServico?.itens)}
          />
        </Grid>
      </>
    );
  };

  const ResumoItem = ({ label, value }) => (
    <Paper elevation={0} sx={itemStyle}>
      <Typography sx={labelStyle}>{label}</Typography>
      <Box sx={valueBadgeStyle}>{formatPrice(value || 0)}</Box>
    </Paper>
  );

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        pl: { sm: "7rem" },
        px: { xs: 1, md: "2rem" },
      }}
    >
      <Grid
        container
        spacing={1}
        sx={{
          maxWidth: { xs: "100%", sm: 620, md: "100%" },
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          mt: 1
        }}
      >
        <Grid container spacing={1} md={9}>
          {abaValue === 1 ? renderTotaisProdutos() : renderTotaisServicos()}
          {showAbaDescontos &&
            (abaValue === 1 ? renderTotaisServicos() : renderTotaisProdutos())}
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={2.4}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          style={{ paddingTop: 0 }}
        >
          <Paper
            elevation={0}
            sx={{
              ...itemStyle,
              flexDirection: "row",
              gap: 1,
              px: 2,
              py: 2,
              width: { xs: "100%", sm: "50%", md: "100%" },
            }}
          >
            <Typography
              sx={{
                fontWeight: 700,
                color: "#1f2937",
                fontSize: { xs: "0.75rem", sm: "0.8rem" },
                whiteSpace: "nowrap",
              }}
            >
              Total Geral:
            </Typography>
            <Box
              sx={{
                backgroundColor: "#2196f3",
                color: "#ffffff",
                padding: { xs: "3px 12px", sm: "4px 16px" },
                borderRadius: "16px",
                fontWeight: 700,
                fontSize: { xs: "0.75rem", sm: "0.8rem" },
                whiteSpace: "nowrap",
                textAlign: "center",
              }}
            >
              {formatPrice(orcamentoServico?.totalOrcamentoServico || 0)}
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={0.5} md={0.5} style={{ paddingTop: 0 }}>
          <IconButton
            variant="contained"
            size="small"
            onClick={toggleAbaDescontos}
          >
            <i
              className="ph-bold ph-caret-down"
              style={{
                color: "#494c62",
                rotate: showAbaDescontos ? "180deg" : "0deg",
              }}
            ></i>
          </IconButton>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ResumoTotal;
